(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8252],{

/***/ 21110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Avatar/avatar.module.sass
var avatar_module = __webpack_require__(16886);
var avatar_module_default = /*#__PURE__*/__webpack_require__.n(avatar_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/Avatar/Avatar.jsx








// import avatar from '../../public/icons/avatar.svg';
var Avatar = function(_param) /*#__PURE__*/ {
    var name = _param.name, userPick = _param.userPick, urlBF = _param.urlBF, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "userPick",
        "urlBF"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (avatar_module_default()).avatar
    }, props), {
        children: !name ? // <img className={styles.avatarImg} src={userPick || avatar} alt={name} />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarImg,
            children: userPick || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatarBf",
                    width: 40,
                    height: 40
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatar",
                    width: 40,
                    height: 40
                })
            })
        }) : // <img
        //   className={styles.avatarImg}
        //   src={ userPick || <AvatarImg />}
        //   alt={name}
        // />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                variant: "linkAsButtonPrimarySm",
                transform: "uppercase",
                children: name
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Avatar/index.js



/***/ }),

/***/ 44804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zu": function() { return /* binding */ riverProfitShips; },
/* harmony export */   "ax": function() { return /* binding */ seaBestReviewsShips; },
/* harmony export */   "qs": function() { return /* binding */ riverBestReviewsShips; },
/* harmony export */   "zA": function() { return /* binding */ seaProfitShips; }
/* harmony export */ });
var riverProfitShips = [
    {
        nameProfitShip: "Волга Стар",
        linkProfitShip: "/ships/volgastar"
    },
    {
        nameProfitShip: "Иван Бунин",
        linkProfitShip: "/ships/ivan-bunin"
    },
    {
        nameProfitShip: "Княжна Анастасия",
        linkProfitShip: "/ships/knyazhna-anactaciya"
    },
    {
        nameProfitShip: "Леонид Красин",
        linkProfitShip: "/ships/leonid-kracin"
    },
    {
        nameProfitShip: "Сергей Кучкин",
        linkProfitShip: "/ships/cergey-kuchkin"
    }, 
];
var riverBestReviewsShips = [
    {
        nameBestRevShip: "Александр Грин",
        linkBestRevShip: "/ships/alekcandr-grin"
    },
    {
        nameBestRevShip: "Андрей Рублев",
        linkBestRevShip: "/ships/andrey-rublev"
    },
    {
        nameBestRevShip: "Лебединое озеро",
        linkBestRevShip: "/ships/lebedinoe-ozero"
    },
    {
        nameBestRevShip: "Ленин",
        linkBestRevShip: "/ships/lenin"
    },
    {
        nameBestRevShip: "Леонид Красин",
        linkBestRevShip: "/ships/leonid-kracin"
    },
    {
        nameBestRevShip: "Максим Горький",
        linkBestRevShip: "/ships/makcim-gor-kiy"
    },
    {
        nameBestRevShip: "Маленький принц",
        linkBestRevShip: "/ships/malenkiy_printz"
    },
    {
        nameBestRevShip: "Мустай Карим",
        linkBestRevShip: "/ships/mustai-karim"
    },
    {
        nameBestRevShip: "Россия",
        linkBestRevShip: "/ships/rossiya"
    },
    {
        nameBestRevShip: "Юрий Никулин",
        linkBestRevShip: "/ships/yury-nikulin"
    }, 
];
var seaProfitShips = [
    {
        nameProfitShip: "Astoria Grande",
        linkProfitShip: "/ships/astoria-grande"
    },
    {
        nameProfitShip: "Aroya",
        linkProfitShip: "/ships/aroya"
    },
    {
        nameProfitShip: "Celestyal Journey",
        linkProfitShip: "/ships/celestyal-journey"
    },
    {
        nameProfitShip: "Celestyal Discovery",
        linkProfitShip: "/ships/celestyal-discovery"
    },
    {
        nameProfitShip: "MSC Divina",
        linkProfitShip: "/ships/msc-divina-"
    },
    {
        nameProfitShip: "MSC Sinfonia",
        linkProfitShip: "/ships/msc-sinfonia"
    }, 
];
var seaBestReviewsShips = [
    {
        nameBestRevShip: "MSC Euribia",
        linkBestRevShip: "/ships/msc-euribia"
    },
    {
        nameBestRevShip: "Spectrum Of The Seas",
        linkBestRevShip: "/ships/spectrum-of-the-seas"
    },
    {
        nameBestRevShip: "MSC FANTASIA",
        linkBestRevShip: "/ships/msc-fantasia"
    },
    {
        nameBestRevShip: "MSC Musica",
        linkBestRevShip: "/ships/msc-musica"
    },
    {
        nameBestRevShip: "MSC Grandiosa",
        linkBestRevShip: "/ships/msc-grandiosa"
    },
    {
        nameBestRevShip: "MSC Splendida",
        linkBestRevShip: "/ships/msc-splendida"
    },
    {
        nameBestRevShip: "Celebrity Millennium",
        linkBestRevShip: "/ships/celebrity-millennium"
    },
    {
        nameBestRevShip: "Anthem Of The Seas",
        linkBestRevShip: "/ships/anthem-of-the-seas"
    },
    {
        nameBestRevShip: "MSC Seaside",
        linkBestRevShip: "/ships/msc-seaside"
    }, 
];


/***/ }),

/***/ 95907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ Login; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Layout/components/Login/login.module.sass
var login_module = __webpack_require__(6647);
var login_module_default = /*#__PURE__*/__webpack_require__.n(login_module);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Avatar/index.js + 1 modules
var Avatar = __webpack_require__(21110);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/PrivateOffice/LoginMenu/loginMenu.module.sass
var loginMenu_module = __webpack_require__(60693);
var loginMenu_module_default = /*#__PURE__*/__webpack_require__.n(loginMenu_module);
// EXTERNAL MODULE: ./utils/checkedDev.js
var checkedDev = __webpack_require__(66131);
;// CONCATENATED MODULE: ./components/PrivateOffice/LoginMenu/LoginMenu.jsx









var LoginMenu = function(param) {
    var onClick = param.onClick, isManager = param.isManager, isMobile = param.isMobile, urlBF = param.urlBF;
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            [
                (loginMenu_module_default()).wrapper
            ],
            (0,_define_property/* default */.Z)({}, (loginMenu_module_default()).wrapperBf, urlBF === "black_friday"), 
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (loginMenu_module_default()).item,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (loginMenu_module_default()).orders,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        variant: "text-7",
                        color: router.route !== "/my/orders" ? "primaryColor" : "dark-color",
                        href: "/my/orders",
                        onClick: function() {
                            return onClick();
                        },
                        className: urlBF === "black_friday" && (loginMenu_module_default()).textItem,
                        children: "Мои заказы"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        variant: "text-7",
                        color: router.route !== "/my/main" ? "primaryColor" : "dark-color",
                        href: "/my/main",
                        onClick: function() {
                            return onClick();
                        },
                        className: urlBF === "black_friday" && (loginMenu_module_default()).textItem,
                        children: "Мой профиль"
                    })
                }),
                isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        variant: "text-7",
                        color: "primaryColor",
                        href: "".concat((0,checkedDev/* checkedDev */.i)("/adm_n/index.html#!")),
                        onClick: function() {
                            return onClick();
                        },
                        className: urlBF === "black_friday" && (loginMenu_module_default()).textItem,
                        children: "Админка"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        variant: "text-7",
                        color: "primaryColor",
                        href: "/reviews",
                        onClick: function() {
                            return onClick();
                        },
                        className: urlBF === "black_friday" && (loginMenu_module_default()).textItem,
                        children: "Отзывы"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (loginMenu_module_default()).buttonWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "text-7",
                        color: "primaryColor",
                        onClick: function() {
                            store.logOut();
                            onClick();
                        },
                        className: urlBF === "black_friday" && (loginMenu_module_default()).textItem,
                        children: "Выход"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/PrivateOffice/LoginMenu/index.js


// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(76627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useInterval.js

var useInterval = function (callback, delay) {
    var savedCallback = (0,react.useRef)(function () { });
    (0,react.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ var esm_useInterval = (useInterval);

;// CONCATENATED MODULE: ./node_modules/@yandex/smart-captcha/module.mjs


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/**
 * Load script on src and run function on script load
 */
function loadScript(src, onload, onerror, onJavascriptError, immediate) {
    if (onload === void 0) { onload = null; }
    if (onerror === void 0) { onerror = null; }
    if (immediate === void 0) { immediate = true; }
    var script = document.createElement('script');
    script.src = src;
    script.onload = onload;
    script.onerror = onerror;
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    if (typeof window !== 'undefined') {
        window.addEventListener('error', function handleJavascriptError(e) {
            if (e.filename.indexOf(src) === 0 && onJavascriptError) {
                onJavascriptError({
                    filename: e.filename,
                    message: e.message,
                    col: e.colno,
                    line: e.lineno,
                });
            }
        });
    }
    var addScript = function () { return document.body.appendChild(script); };
    if (immediate) {
        addScript();
    }
    else {
        window.addEventListener('load', addScript);
    }
}

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */
var domainRE = /^(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
function isValidHost(str) {
    if (typeof str !== 'string') {
        return false;
    }
    var match = str.match(domainRE);
    if (!match) {
        return false;
    }
    var everythingAfterProtocol = match[0];
    if (!everythingAfterProtocol) {
        return false;
    }
    if (localhostDomainRE.test(everythingAfterProtocol) ||
        nonLocalhostDomainRE.test(everythingAfterProtocol)) {
        return true;
    }
    return false;
}

var API_LINK = function (host) {
    if (host === void 0) { host = 'smartcaptcha.yandexcloud.net'; }
    return "https://" + host + "/captcha.js?render=onload&onload=__onSmartCaptchaReady";
};

/**
 * @internal
 */
var callbacks = [];
var startLoading = new Map();
function useSmartCaptchaLoader(host, onJavascriptError) {
    var _a = __read((0,react.useState)(), 2), smartCaptcha = _a[0], setSmartCaptcha = _a[1];
    (0,react.useEffect)(function () {
        if (smartCaptcha !== undefined || (host !== undefined && !isValidHost(host))) {
            return;
        }
        if (window.__onSmartCaptchaReady === undefined) {
            window.__onSmartCaptchaReady = function () {
                callbacks.forEach(function (callback) { return callback(); });
            };
        }
        if (window.smartCaptcha) {
            setSmartCaptcha(window.smartCaptcha);
        }
        var index = callbacks.push(function () { return setSmartCaptcha(window.smartCaptcha); });
        var handleError = function () {
            onJavascriptError === null || onJavascriptError === void 0 ? void 0 : onJavascriptError({
                filename: API_LINK(host),
                message: 'Unknown error on script loading',
                col: 0,
                line: 0
            });
        };
        if (!startLoading.get(host)) {
            loadScript(API_LINK(host), null, handleError, onJavascriptError);
            startLoading.set(host, true);
        }
        return function () {
            callbacks.splice(index, 1);
        };
    }, [host, onJavascriptError, smartCaptcha]);
    return smartCaptcha;
}

function useSubscriptions(props) {
    var propsRef = (0,react.useRef)({});
    var widgetId = props.widgetId, smartCaptcha = props.smartCaptcha, onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError;
    propsRef.current = {
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError,
    };
    (0,react.useEffect)(function () {
        if (!smartCaptcha || typeof widgetId !== 'number') {
            return;
        }
        var unsubscribeFns = [
            smartCaptcha.subscribe(widgetId, 'challenge-visible', function () {
                var _a, _b;
                (_b = (_a = propsRef.current).onChallengeVisible) === null || _b === void 0 ? void 0 : _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, 'challenge-hidden', function () {
                var _a, _b;
                (_b = (_a = propsRef.current).onChallengeHidden) === null || _b === void 0 ? void 0 : _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, 'network-error', function () {
                var _a, _b;
                (_b = (_a = propsRef.current).onNetworkError) === null || _b === void 0 ? void 0 : _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, 'success', function (token) {
                var _a, _b;
                (_b = (_a = propsRef.current).onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, token);
            }),
            smartCaptcha.subscribe(widgetId, 'token-expired', function () {
                var _a, _b;
                (_b = (_a = propsRef.current).onTokenExpired) === null || _b === void 0 ? void 0 : _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, 'javascript-error', function (error) {
                var _a, _b;
                (_b = (_a = propsRef.current).onJavascriptError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
            }),
        ];
        return function () { return unsubscribeFns.forEach(function (fn) { return fn === null || fn === void 0 ? void 0 : fn(); }); };
    }, [widgetId, smartCaptcha]);
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;

var style = { height: 102 };
var SmartCaptcha = function (props) {
    var containerRef = (0,react.useRef)(null);
    var onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError, language = props.language, host = props.host, restProps = __rest(props, ["onChallengeHidden", "onChallengeVisible", "onSuccess", "onNetworkError", "onTokenExpired", "onJavascriptError", "language", "host"]);
    var smartCaptcha = useSmartCaptchaLoader(host, onJavascriptError);
    var _a = __read((0,react.useState)(), 2), widgetId = _a[0], setWidgetId = _a[1];
    var destroyedRef = (0,react.useRef)({});
    useSubscriptions({
        widgetId: widgetId,
        smartCaptcha: smartCaptcha,
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError
    });
    useIsomorphicLayoutEffect(function () {
        if (!containerRef.current || !smartCaptcha) {
            return;
        }
        var id = smartCaptcha.render(containerRef.current, __assign(__assign({}, restProps), { hl: language }));
        setWidgetId(id);
        return function () {
            smartCaptcha.destroy(id);
            setWidgetId(undefined);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            destroyedRef.current[id] = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [smartCaptcha, language, restProps.sitekey, restProps.test, restProps.webview]);
    return react.createElement("div", { ref: containerRef, className: "smart-captcha", style: style });
};

var InvisibleSmartCaptcha = function (props) {
    var containerRef = useRef(null);
    var onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError, language = props.language, host = props.host, restProps = __rest(props, ["onChallengeHidden", "onChallengeVisible", "onSuccess", "onNetworkError", "onTokenExpired", "onJavascriptError", "language", "host"]);
    var smartCaptcha = useSmartCaptchaLoader(host, onJavascriptError);
    var _a = __read(useState(), 2), widgetId = _a[0], setWidgetId = _a[1];
    var destroyedRef = useRef({});
    useSubscriptions({
        widgetId: widgetId,
        smartCaptcha: smartCaptcha,
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError
    });
    useIsomorphicLayoutEffect(function () {
        if (!containerRef.current || !smartCaptcha) {
            return;
        }
        var id = smartCaptcha.render(containerRef.current, __assign(__assign({}, restProps), { invisible: true, hl: language }));
        setWidgetId(id);
        return function () {
            smartCaptcha === null || smartCaptcha === void 0 ? void 0 : smartCaptcha.destroy(id);
            setWidgetId(undefined);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            destroyedRef.current[id] = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        smartCaptcha,
        language,
        restProps.hideShield,
        restProps.shieldPosition,
        restProps.sitekey,
        restProps.test,
        restProps.webview,
    ]);
    useEffect(function () {
        if (smartCaptcha &&
            restProps.visible &&
            typeof widgetId === 'number' &&
            !destroyedRef.current[widgetId]) {
            smartCaptcha.execute(widgetId);
        }
    }, [smartCaptcha, restProps.visible, widgetId]);
    return React.createElement("div", { ref: containerRef, className: "smart-captcha" });
};



// EXTERNAL MODULE: ./utils/unFormatterPhone.js
var unFormatterPhone = __webpack_require__(23104);
// EXTERNAL MODULE: ./components/Input/index.js + 2 modules
var Input = __webpack_require__(21794);
;// CONCATENATED MODULE: ./components/Layout/components/Login/Steps/FirstStep.jsx
// TODO https://gist.github.com/Kafkae/e9f58fae735961e688319fab6a4fe7d8
















var LoginSchema = index_esm/* object */.Ry().shape({
    phone: index_esm/* string */.Z_().trim().min(11, "").max(11, "").required("Required")
});
var FirstStep = (0,es/* observer */.Pi)(function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var ref = (0,react.useState)(null), token = ref[0], setToken = ref[1];
    var setPhone = function(phone, typePhone) {
        return store.setPhone(phone, typePhone);
    };
    esm_useInterval(function() {
        store.getPhonePolling(store.phone);
    }, store.phone ? 5000 : null);
    var getCode = function() {
        return store.getCode(token);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var setFieldError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setFieldError = param.setFieldError;
                            _ctx.prev = 1;
                            setPhone(values.phone, "");
                            setPhone(values.formatPhone, "formatPhone");
                            _ctx.next = 6;
                            return getCode();
                        case 6:
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            setFieldError("phone", "Не нашли номер, попробуйте еще раз");
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        validationSchema: LoginSchema,
        initialValues: {
            phone: "",
            formatPhone: ""
        },
        children: function(param) {
            var values = param.values, isValid = param.isValid, dirty = param.dirty, setFieldValue = param.setFieldValue, isSubmitting = param.isSubmitting, touched = param.touched, errors = param.errors;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "famyle",
                        bottomGap: 32,
                        children: "Бронируя круиз, вы автоматически регистрируетесь на сайте"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                        id: "phone",
                        control: (react_input_mask_default()),
                        values: values.phone,
                        mask: "+7 999 999-99-99",
                        autoComplete: "off",
                        placeholder: "Номер телефона",
                        label: "Номер телефона",
                        maskChar: "",
                        onChange: function(e) {
                            setFieldValue("formatPhone", e.target.value);
                            setFieldValue("phone", (0,unFormatterPhone/* unFormatterPhone */.Z)(e.target.value));
                        },
                        error: touched.phone && errors.phone
                    }),
                    store.toggledModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (login_module_default()).captcha,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCaptcha, {
                                sitekey: "ysc1_L95zJFarTqHBIm800oQupSJHIRSYv2U2WZc6HeHic61c272c",
                                onSuccess: setToken
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: "lg",
                        fullWidth: true,
                        topGap: true,
                        type: "submit",
                        disabled: !(isValid && dirty) || isSubmitting || !token,
                        children: isSubmitting ? "Ищем номер" : "Продолжить"
                    })
                ]
            });
        }
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Login/Steps/SecondStep.jsx















var AutoSubmitToken = function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var setFieldError = (0,formik_esm/* useFormikContext */.u6)().setFieldError;
    esm_useInterval(function() {
        if (!store.phone) {
            return;
        }
        if (store.toggledModal) {
            store.getPhonePolling(store.phone);
        }
    }, store.toggledModal ? 5000 : null);
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        setFieldError("code", (ref1 = (ref = store.error) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        store.error
    ]);
    return null;
};
var SecondStep = (0,es/* observer */.Pi)(function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var ref = (0,react.useState)(null), token = ref[0], setToken = ref[1];
    var ref1 = (0,react.useState)(0), captchaCount = ref1[0], setCaptchaCount = ref1[1];
    var phone = store === null || store === void 0 ? void 0 : store.formatPhone;
    var setShowCaptcha = function(count) {
        return store.setShowCaptcha(count);
    };
    var showCaptcha = store.showCaptcha;
    var retrySendCode = function() {
        return store.retrySendCode(token);
    };
    (0,react.useEffect)(function() {
        store.getShowCaptcha();
    }, []);
    var sendRetryCode = function() {
        if (token) {
            retrySendCode();
        } else if (captchaCount < 1) {
            retrySendCode();
        }
    };
    var authByCode = function(code) {
        return store.authByCode(code);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            code: ""
        },
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var setFieldError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setFieldError = param.setFieldError;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return authByCode(values.code);
                        case 4:
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](1);
                            setFieldError("code", "Не нашли номер, попробуйте еще раз!");
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        6
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var values = param.values, setFieldValue = param.setFieldValue, touched = param.touched, errors = param.errors;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                        id: "code",
                        control: (react_input_mask_default()),
                        values: values.code,
                        placeholder: "Введите код",
                        label: "Введите код",
                        maskChar: "",
                        autoComplete: "off",
                        onChange: function(e) {
                            setFieldValue("code", e.target.value);
                            window.ym(35441960, "reachGoal", "authorization_sms");
                        },
                        error: touched.code && errors.code
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSubmitToken, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (login_module_default()).checkCode,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Мы отправили вам код на номер ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: phone
                                    }),
                                    ".",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                size: "lg",
                                fullWidth: true,
                                topGap: true,
                                type: "submit",
                                children: "Продолжить"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                view: "text",
                                onClick: function() {
                                    setCaptchaCount(captchaCount + 1);
                                    setShowCaptcha(captchaCount);
                                    sendRetryCode();
                                    setToken(null);
                                },
                                className: (0,classcat/* default */.Z)([
                                    (0,_define_property/* default */.Z)({}, (login_module_default()).disabled, !token && showCaptcha)
                                ]),
                                children: "Отправить новый код"
                            }),
                            showCaptcha && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCaptcha, {
                                sitekey: "ysc1_L95zJFarTqHBIm800oQupSJHIRSYv2U2WZc6HeHic61c272c",
                                onSuccess: setToken
                            }, captchaCount),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                view: "text",
                                onClick: function() {
                                    if (store.strategySignIn !== "authSteps") {
                                        store.setStep("phoneInput");
                                    } else {
                                        store.setToggledModal(false);
                                    }
                                },
                                children: "Изменить номер"
                            })
                        ]
                    })
                ]
            });
        }
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Login/Steps/loginAttempts.jsx







var LoginAttempts = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
            bottomGap: 8,
            children: [
                "Закончились попытки входа. ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Просим обратиться за помощью к менеджеру по телефону",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "+7 499 955-46-01"
                }),
                "."
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Login/Steps/lackPersonalArea.jsx







var LackPersonalArea = (0,es/* observer */.Pi)(function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                bottomGap: 8,
                children: [
                    "У вас пока нет личного кабинета.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Забронируйте круиз, чтобы его создать, или введите номер, который вы использовали при бронировании."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (login_module_default()).contactsWhatsApp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    view: "text",
                    onClick: function() {
                        store.setStep("phoneInput");
                    },
                    children: "Изменить номер"
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
;// CONCATENATED MODULE: ./components/Features/ModalAuth/ModalAuth.jsx










var ModalAuth = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile, setToggledModal = param.setToggledModal;
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    // const setToggledModal = toggledModal => store.setToggledModal(toggledModal);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            size: "dialog",
            onOpen: setToggledModal,
            isOpen: store.toggledModal,
            title: "Вход",
            bottomGap: 20,
            isMobile: isMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm/* Switch */.rs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                        condition: store.step === "phoneInput",
                        children: store.strategySignIn !== "authSteps" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstStep, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondStep, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                        condition: store.step === "codeInput",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondStep, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                        condition: store.step === "loginAttempts",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAttempts, {
                            isMobile: isMobile
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                        condition: store.step === "lackPersonalArea",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LackPersonalArea, {})
                    })
                ]
            })
        })
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Login/Login.jsx
// TODO https://gist.github.com/Kafkae/e9f58fae735961e688319fab6a4fe7d8


















var Login = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile, isOutsPage = param.isOutsPage, isStep = param.isStep, urlBF = param.urlBF;
    var ref, ref1;
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var count = (0,RootStoreProvider/* useFavorites */.rc)().items.length;
    var ref2 = (0,react.useRef)();
    var ref3 = (0,react.useState)(false), showMenu = ref3[0], setShowMenu = ref3[1];
    var setToggledModal = function(toggledModal, strategy) {
        return store.setToggledModal(toggledModal, strategy);
    };
    (0,react.useEffect)(function() {
        if (!store.toggledModal) {
            return;
        }
        document.body.classList.add("body-scroll-lock");
        // eslint-disable-next-line consistent-return
        return function() {
            document.body.classList.remove("body-scroll-lock");
            setTimeout(function() {
                // убираем баг с модалкой капчи
                document.body.style.overflow = "";
            }, 500);
        };
    }, [
        store.toggledModal
    ]);
    var myStore = (0,RootStoreProvider/* useMyCabinetStore */.Hm)();
    (0,useClickAway/* default */.Z)(ref2, function() {
        if (showMenu) {
            setShowMenu(false);
        }
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (login_module_default()).wrapper,
            children: [
                !isStep && isClient/* isClient */.C && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/cart",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (login_module_default()).favorite,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (login_module_default()).heart,
                                children: [
                                    urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "common/cartBf",
                                            width: 36,
                                            height: 36
                                        }),
                                        alt: "Корзина",
                                        title: "Корзина"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "common/cart",
                                            width: 36,
                                            height: 36
                                        }),
                                        alt: "Корзина",
                                        title: "Корзина"
                                    }),
                                    count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,classcat/* default */.Z)([
                                    [
                                        (login_module_default()).favoriteText
                                    ],
                                    (0,_define_property/* default */.Z)({}, (login_module_default()).favoriteTextBf, urlBF === "black_friday"), 
                                ]),
                                children: "Корзина"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                    condition: store.isLoggedIn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (login_module_default()).login,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                                    condition: isMobile,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        className: (login_module_default()).lkButtonWrapper,
                                                        onClick: function() {
                                                            return setShowMenu(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                            urlBF: urlBF
                                                        })
                                                    }),
                                                    showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        ref: ref2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginMenu, {
                                                            count: myStore === null || myStore === void 0 ? void 0 : (ref = myStore.nextOrder) === null || ref === void 0 ? void 0 : ref.length,
                                                            onClick: function(click) {
                                                                setShowMenu(click);
                                                            },
                                                            isManager: store.isManager,
                                                            isMobile: isMobile,
                                                            urlBF: urlBF
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (login_module_default()).loginContentButton,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                            urlBF: urlBF,
                                                            className: (login_module_default()).loginContentAvatar,
                                                            onClick: function() {
                                                                return setShowMenu(true);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,classcat/* default */.Z)([
                                                            [
                                                                (login_module_default()).buttonWrapper
                                                            ],
                                                            (0,_define_property/* default */.Z)({}, (login_module_default()).buttonWrapperBf, urlBF === "black_friday"), 
                                                        ]),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            variant: "text-5",
                                                            onClick: function() {
                                                                return setShowMenu(true);
                                                            },
                                                            children: "Личный кабинет"
                                                        })
                                                    }),
                                                    showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        ref: ref2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginMenu, {
                                                            count: myStore === null || myStore === void 0 ? void 0 : (ref1 = myStore.nextOrder) === null || ref1 === void 0 ? void 0 : ref1.length,
                                                            onClick: function(click) {
                                                                setShowMenu(click);
                                                            },
                                                            isManager: store.isManager,
                                                            isB2bMode: store.isB2bMode,
                                                            isMobile: isMobile,
                                                            urlBF: urlBF
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                            children: !isOutsPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: function() {
                                    setToggledModal(true);
                                },
                                size: "md",
                                className: (0,classcat/* default */.Z)([
                                    [
                                        (login_module_default()).button
                                    ],
                                    (_obj = {}, (0,_define_property/* default */.Z)(_obj, (login_module_default()).buttonBf, urlBF === "black_friday"), (0,_define_property/* default */.Z)(_obj, (login_module_default()).buttonGap, isMobile), _obj), 
                                ]),
                                children: "Войти"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuth, {
                    isMobile: isMobile,
                    setToggledModal: setToggledModal
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/Layout/components/Login/index.js



/***/ }),

/***/ 5475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/Logo/Logo.jsx






// import white from '../../public/icons/white.svg';
// import Logotype from '../../public/icons/logotype.svg';

var Logo = function(param) {
    var _link = param.link, link = _link === void 0 ? "/" : _link, _w = param.w, w = _w === void 0 ? 208 : _w, _h = param.h, h = _h === void 0 ? 32 : _h, _target = param.target, target = _target === void 0 ? false : _target, urlBF = param.urlBF;
    var linkProps = target ? {
        target: "_blank",
        rel: "noreferrer"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                children: urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                        name: "common/logotypeBlack",
                        width: w,
                        height: h
                    }),
                    title: "Логотип. Круиз Онлайн.",
                    alt: "Логотип. Круиз Онлайн."
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                        name: "common/logotype",
                        width: w,
                        height: h
                    }),
                    title: "Логотип. Круиз Онлайн.",
                    alt: "Логотип. Круиз Онлайн."
                })
            }))
        })
    });
};

;// CONCATENATED MODULE: ./components/Logo/index.js



/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.u; }
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31735);



/***/ }),

/***/ 16203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useCheckStep1Unregistered; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var useCheckStep1Unregistered = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isStep1Unregistered = ref[0], setIsStep1Unregistered = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (router.isReady) {
            var currentPath = router.asPath; // Получаем текущий путь с query строкой
            // Проверяем, содержит ли URL `step_1_unregistered`
            if (currentPath.includes("step_1_unregistered")) {
                setIsStep1Unregistered(true);
            } else {
                setIsStep1Unregistered(false);
            }
        }
    }, [
        router.isReady,
        router.asPath
    ]);
    return isStep1Unregistered;
};


/***/ }),

/***/ 66131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ checkedDev; }
/* harmony export */ });
/* harmony import */ var _isClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69594);

var checkedDev = function(url) {
    console.log("@@@ location", _isClient__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C && (window === null || window === void 0 ? void 0 : window.location.hostname));
    if (false) {}
    if (_isClient__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C && (window === null || window === void 0 ? void 0 : window.location.hostname) === "test.kruiz.tech") {
        console.log("@@@ tech");
        return "https://test.kruiz.tech".concat(url);
    }
    return "https://kruiz.online".concat(url);
};


/***/ }),

/***/ 16886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__Khlbh","avatarImg":"avatar_avatarImg__b7gUj"};

/***/ }),

/***/ 6647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__vNaaC","checkCode":"login_checkCode__LzYeX","login":"login_login__HP4cd","lkButtonWrapper":"login_lkButtonWrapper__bRpRb","buttonWrapper":"login_buttonWrapper__c8v24","buttonWrapperBf":"login_buttonWrapperBf__F6_nF","button":"login_button__ZLp3n","buttonBf":"login_buttonBf__hLHn0","buttonGap":"login_buttonGap__pu65D","favorite":"login_favorite__rgeA_","favoriteText":"login_favoriteText__PxQjo","favoriteTextBf":"login_favoriteTextBf__hI3Dk","heart":"login_heart__VGHMj","loginContentButton":"login_loginContentButton__ZEDzD","loginContentAvatar":"login_loginContentAvatar__7UNX8","contactsWhatsApp":"login_contactsWhatsApp__mBPDU","captcha":"login_captcha__UzxPL","disabled":"login_disabled__JBUAe"};

/***/ }),

/***/ 60693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loginMenu_wrapper__Q2P7b","wrapperBf":"loginMenu_wrapperBf__xo9W0","textItem":"loginMenu_textItem__IQZO5","item":"loginMenu_item__EtEuh","buttonWrapper":"loginMenu_buttonWrapper__6MQBi","orders":"loginMenu_orders__p_yIg","ordersCount":"loginMenu_ordersCount__anBYV"};

/***/ })

}]);